import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const WORKSPACE_TEAM: ObjectTypeConfig = {
  actions: [
    // Open leads — same position as every other resource menu.
    {
      id: "open",
      surfaces: ["left-rail"],
      presentation: "menu-item",
    },
    // Creation — a workspace is a container, so creation follows Open (at the
    // top level; folder-scoped creation lives on the Canvases/Chats/Files
    // section kebabs). Handler-gated: surfaces that don't wire
    // newCanvas/newChat (cards, page header) simply don't show them.
    {
      id: "new-canvas",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "new-chat",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "edit-workspace",
      surfaces: ["left-rail", "page-header", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "add-members",
      surfaces: ["left-rail", "page-header", "context-menu"],
      presentation: "menu-item",
    },
    // Container actions — only where files can be uploaded (files tab). Hidden on
    // the workspaces tab / cards / page header so the same workspace shows one
    // menu everywhere except for these context-gated extras.
    {
      id: "new-folder",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.notFileUploadContext,
    },
    {
      id: "upload-files",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.notFileUploadContext,
    },
    {
      id: "delete",
      surfaces: ["left-rail", "page-header", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.privateWorkspace,
    },
  ],
};

export const WORKSPACE_PRIVATE: ObjectTypeConfig = {
  actions: [
    // Open leads — same position as every other resource menu.
    {
      id: "open",
      surfaces: ["left-rail"],
      presentation: "menu-item",
    },
    // My Workspace can't be edited/shared/trashed, but it's still a container —
    // creation actions are the rest of its rail menu.
    {
      id: "new-canvas",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "new-chat",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    // My Workspace on the files tab is a file container too (no edit/members/delete).
    {
      id: "new-folder",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.notFileUploadContext,
    },
    {
      id: "upload-files",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.notFileUploadContext,
    },
  ],
};
